import React, { useEffect, useState } from 'react'
import { useRef } from 'react';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { InputLabel, FormControl, Select, MenuItem, FormGroup } from '@mui/material';
import axios from "../../lib/axios";

const CustomTextField = styled(TextField)(({ theme }) => ({
  '& .MuiFilledInput-root': {
    backgroundColor: 'transparent',
    border: '1px solid #e0e0e0',
    borderRadius: '4px',
  },
  '& .Mui-focused': {
    borderColor: '#673ab7',
  },
  '& .MuiFilledInput-root.Mui-focused': {
    border: '1px solid #673ab7',
  },
}));


const EmailConfigurationForm = () => {

  const [formData, setFormData] = useState({
    PropName: '',
    UserName: '',
    FromEmail: '',
    EmailPass: '',
    Smtp: '',
    PortNo: '',
    Essl: "1",
    Status: "1",
    CreatedBy: "",
    UpdatedBy: ""
  });

  const [error, setError] = useState({

  });
  const navigate = useNavigate();
  const [isEditMode, setIsEditMode] = useState(false);
  const [isFormDisabled, setIsFormDisabled] = useState(true);
  const location = useLocation();
  const [currentEmailConfigId, setCurrentEmailConfigId] = useState(null);
  const [propertyOptions, setPropertyOptions] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [isViewMode, setIsViewMode] = useState(false);
  const [mode, setMode] = useState('view');
  const [lastInsertedEmailConfigId, setLastInsertedEmailConfigId] = useState(null);
  const [emailConfigData, setEmailConfigData] = useState([]);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const UserId = sessionStorage.getItem('UserId')
  const [Status, setStatus] = useState(false);
  const emailPassRef = useRef(null);


  const fetchEmailConfigData = async (id, flag) => {
    try {
      const response = await axios.post(`EmailRequest/RetriveEmailRequest`, {
        EmailConfigId: parseInt(id),
        Flag: flag
      });

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        const emailConfigData = response.data.Data[0];
        setFormData({
          PropName: emailConfigData.PropId.toString(),
          UserName: emailConfigData.UserId.toString(),
          FromEmail: emailConfigData.FromEmail,
          EmailPass: emailConfigData.EmailPass,
          Smtp: emailConfigData.Smtp,
          PortNo: emailConfigData.PortNo,
          Essl: emailConfigData.Essl.toString(),
          Status: emailConfigData.Status.toString(),
        });
        
        setIsFormDisabled(true);
        setEmailConfigData(emailConfigData.EmailConfigId);
      } else if (response.data.Status === 1 && response.data.responseStatusCode === 2) {
        toast.info(response.data.Message);
      } else {
        toast.error('Failed to fetch email configuration data');
      }
    } catch (error) {
      console.error('Error fetching email configuration data:', error);
      toast.error('Failed to fetch email configuration data.');
    }
  };

  // Define fetchPropertyOptions outside of useEffect
  const fetchPropertyOptions = async () => {
    try {
      const response = await axios.post(`PropertyMst/getPropertyMstdrp`, {
        UserId,
        Flag: ""
      });
      if (
        response.data.Status === 0 &&
        response.data.responseStatusCode === 1
      ) {
        setPropertyOptions(response.data.Data);
      } else {
        toast.error("Failed to fetch PropertyName");
      }
    } catch (error) {
      console.error("Error fetching PropertyName", error);
      toast.error("Error fetching PropertyName. Please try again.");
    }
  };

  // Location effect
  useEffect(() => {
    if (location?.state?.EmailConfigId) {
      setCurrentEmailConfigId(location.state.EmailConfigId);
      fetchEmailConfigData(location.state.EmailConfigId);
      setMode('view');
    } else {
      setMode('add');
      setIsFormDisabled(false);
    }
  }, [location]);

  // Property options effect
  useEffect(() => {
    fetchPropertyOptions();
  }, []);

  // User options effect
  useEffect(() => {
    const fetchUserOptions = async () => {
      try {
        const response = await axios.post(`UserMst/GetMakeDropDown`);
        if (
          response.data.Status === 0 &&
          response.data.responseStatusCode === 1
        ) {
          setUserOptions(response.data.Data);
        } else {
          toast.error("Failed to fetch UserName");
        }
      } catch (error) {
        console.error("Error fetching UserName", error);
        toast.error("Error fetching UserName. Please try again.");
      }
    };

    fetchUserOptions();
  }, []);



  const handlePrevious = async () => {
    if (currentEmailConfigId && currentEmailConfigId > 1) {
      await fetchEmailConfigData(currentEmailConfigId, 'P');
    }
  };
  const handleNext = async () => {
    if (currentEmailConfigId) {
      await fetchEmailConfigData(currentEmailConfigId, 'N');
    }
  };

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;

    if (type === 'checkbox') {
      setFormData(prevState => ({
        ...prevState,
        [name]: checked ? "1" : "0"
      }));
    } else {
      setFormData(prevState => ({
        ...prevState,
        [name]: value
      }));
    }

    if (name === 'EmailConfiguration') {
      setFormData(prevState => ({
        ...prevState,
        state: ''
      }));
    }
  };

  const handleChangeStatus = (e) => {
    setStatus((prev) => !prev);
    let status = e.target.checked ? 1 : 0;
    console.log("statuscheck", status);
  };

  // const handleKeyPress = (event) => {
  //   if (event.key === 'Enter' && emailPassRef.current) {
  //     emailPassRef.current.focus();
  //   }
  // };

  const handleSave = async () => {
    try {
      const payload = {
        UserId: parseInt(formData.UserName),
        PropId: parseInt(formData.PropName),
        FromEmail: formData.FromEmail,
        EmailPass: formData.EmailPass,
        Smtp: formData.Smtp,
        PortNo: formData.PortNo,
        Essl: formData.Essl, // Will be "1" or "0"
        Status: formData.Status // Will be "1" or "0"
      };

      let response;
      if (mode === 'edit') {
        payload.EmailConfigId = currentEmailConfigId;
        payload.UpdatedBy = parseInt(UserId, 10);
        response = await axios.patch('EmailRequest/UpdateEmailConfig', payload);
      } else {
        payload.CreatedBy = parseInt(UserId, 10);
        response = await axios.post('EmailRequest/InsertEmailConfig', payload);
      }

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        toast.success(response.data.Message);
        if (mode === 'add') {
          setLastInsertedEmailConfigId(response.data.Data)
          await fetchEmailConfigData(response.data.Data);
          setMode('view');
          setIsFormDisabled(true);
          setCurrentEmailConfigId(response.data.Data);
        } else {
          setMode('view');
        }
        setIsFormDisabled(true);
      } else {
        toast.error(response.data.Message || 'Operation failed');
      }
    } catch (error) {
      console.error('Error saving/updating email configuration', error);
      toast.error('Error saving/updating email configuration. Please try again.');
    }
  };



  const handleEdit = () => {
    setMode('edit');
    setIsFormDisabled(false);
  };

  const handleAdd = () => {
    setFormData({
      PropName: '',
      UserName: '',
      FromEmail: '',
      EmailPass: '',
      Smtp: '',
      PortNo: '',
      Essl: true,
      Status: true,
    });
    setMode('add');
    setCurrentEmailConfigId(null);
    setIsFormDisabled(false);
  };


  const handleCancel = async () => {
    try {
      await fetchEmailConfigData(1, "L");
      setMode('view');
      setIsFormDisabled(true);
    } catch (error) {
      toast.error('Error occurred while cancelling. Please try again.');
    }
  };
  const resetForm = () => {
    setFormData({
      FromEmail: '',
      EmailPass: '',
      Smtp: '',
      PortNo: '',
      Essl: true,
      Status: true,
      PropName: '',
      UserName: '',
      CreatedBy: "",
      UpdatedBy: "",
    });
    setCurrentEmailConfigId(null);
    setMode('view');
    setIsFormDisabled(true);
  };
  const handleExit = () => {
    navigate('/emailconfig-table')
  }

  const handleDeleteClick = () => {
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };
  const handleConfirmDelete = async () => {
    setOpenConfirmDialog(false);
    try {
      await fetchEmailConfigData(currentEmailConfigId, "D");
      await fetchEmailConfigData(currentEmailConfigId, "N");
      setMode('view');
      setIsFormDisabled(true);
      // resetForm();
      // setMode('add');
    } catch (error) {
      console.error('Error deleting email configuration', error);
      toast.error('Error occurred while deleting. Please try again.');
    }
  };

  return (
    <>

      <Box className="form-container">

        <ToastContainer />
        <Grid container spacing={2} className='form_grid'>
          <Grid item xs={12} className='form_title' sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '20px' }}>
            <Grid>
              <Button
                variant="contained"
                size="small"
                className='three-d-button-previous'
                onClick={handlePrevious}
                disabled={mode !== 'view' || !currentEmailConfigId || currentEmailConfigId === 1}
              >
                <KeyboardArrowLeftIcon />
              </Button>

              <Button
                variant="contained"
                size="small"
                sx={{ margin: '0px 10px' }}
                className='three-d-button-next'
                onClick={handleNext}
                disabled={mode !== 'view' || !currentEmailConfigId}
              >
                <NavigateNextIcon />
              </Button>
            </Grid>
            <h3>Email Configuration</h3>
            <Grid sx={{ display: 'flex', justifyContent: 'end' }}>
              <Button
                variant="contained"
                size="small"
                sx={{ backgroundColor: '#635bff' }}
                onClick={handleAdd}
                disabled={mode !== 'view' || !currentEmailConfigId}
              >
                <AddIcon />
              </Button>
              <Button
                variant="contained"
                size="small"
                sx={{ backgroundColor: '#635bff', margin: '0px 10px' }}
                onClick={handleEdit}
                disabled={mode !== 'view' || !currentEmailConfigId}
              >
                <EditIcon />
              </Button>
              <Button
                variant="contained"
                size="small"
                sx={{ backgroundColor: '#635bff' }}
                onClick={handleDeleteClick}
                disabled={mode !== 'view' || !currentEmailConfigId || currentEmailConfigId === 1}
              >
                <DeleteIcon />
              </Button>

              <Button
                variant="contained"
                size="small"
                sx={{ backgroundColor: '#635bff', margin: '0px 10px' }}
                onClick={handleExit}
                disabled={mode !== 'view' || !currentEmailConfigId}
              >
                <CancelPresentationIcon />
              </Button>
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_field">
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <FormControl variant="filled" fullWidth className="custom-select">
                  <InputLabel id="PropName-label">Property</InputLabel>
                  <Select
                    labelId="PropName-label"
                    name="PropName"
                    className="custom-textfield"
                    value={formData.PropName}
                    disabled={isFormDisabled}
                    onChange={handleInputChange}
                  >
                    {propertyOptions.map((property) => (
                      <MenuItem key={property.Id} value={property.Id}>
                        {property.Name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={6}>
                <FormControl variant="filled" fullWidth className="custom-select">
                  <InputLabel id="UserName-label">User</InputLabel>
                  <Select
                    labelId="UserName-label"
                    name="UserName"
                    value={formData.UserName}
                    className="custom-textfield"
                    disabled={isFormDisabled}
                    onChange={handleInputChange}
                  >
                    {userOptions.map((user) => (
                      <MenuItem key={user.Id} value={user.Id}>
                        {user.Name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

              </Grid>

              {/* From Email Field */}
              <Grid item xs={12} md={6}>
                <TextField
                  label="From Email"
                  fullWidth
                  variant="filled"
                  className="custom-textfield"
                  value={formData.FromEmail}
                  onChange={handleInputChange}
                  name="FromEmail"
                  required
                  error={error.fromEmail}
                  helperText={error.fromEmail ? 'From Email is required' : ''}
                  disabled={isFormDisabled}
                />
              </Grid>

              {/* Password Field */}
              <Grid item xs={12} md={6}>
                <TextField
                  label="Password"
                  type="password"
                  fullWidth
                  variant="filled"
                  className="custom-textfield"
                  value={formData.EmailPass}
                  onChange={handleInputChange}
                  name="EmailPass"
                  required
                  error={error.EmailPass}
                  helperText={error.EmailPass ? 'Password is required' : ''}
                  disabled={isFormDisabled}
                />
              </Grid>

              {/* SMTP Field */}
              <Grid item xs={12} md={6}>
                <TextField
                  label="SMTP"
                  fullWidth
                  variant="filled"
                  className="custom-textfield"
                  value={formData.Smtp}
                  onChange={handleInputChange}
                  name="Smtp"
                  required
                  error={error.smtp}
                  helperText={error.smtp ? 'SMTP is required' : ''}
                  disabled={isFormDisabled}
                />
              </Grid>

              {/* Port Field */}
              <Grid item xs={12} md={6}>
                <TextField
                  label="Port"
                  fullWidth
                  variant="filled"
                  className="custom-textfield"
                  name="PortNo"
                  value={formData.PortNo}
                  onChange={handleInputChange}

                  required
                  error={error.PortNo}
                  helperText={error.PortNo ? 'Port is required' : ''}
                  disabled={isFormDisabled}
                />
              </Grid>

              {/* SSL Checkbox */}
              <Grid item xs={12} md={6}>
              <FormControlLabel
          control={
            <Checkbox
              checked={formData.Essl === "1"}
              onChange={handleInputChange}
              name="Essl"
              color="primary"
              size="small"
              disabled={isFormDisabled}
            />
          }
          label="SSL"
          labelPlacement="start"
        />
              </Grid>

              {/* Status Checkbox */}
              <Grid item xs={12} md={6}>
              <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={formData.Status === "1"}
                onChange={handleInputChange}
                name="Status"
                color="primary"
                disabled={isFormDisabled}
              />
            }
            label="Status"
          />
                </FormGroup>
              </Grid>
            </Grid>
          </Grid>


          <Grid item xs={12} className="form_button">
            {mode === 'view' && (
              <>
                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }} onClick={handleAdd} disabled>
                  Submit
                </Button>
                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }} onClick={handleEdit}
                  disabled
                >
                  Cancel
                </Button>
              </>
            )}
            {(mode === 'edit' || mode === 'add') && (
              <>

                <Button variant="contained" sx={{ mr: 1 }} onClick={handleSave}>
                  Submit
                </Button>
                <Button variant="contained" sx={{ mr: 1 }} onClick={handleCancel}>
                  Cancel
                </Button>

              </>
            )}
          </Grid>
        </Grid>
      </Box>

      {/* Delete Confirmation Modal */}
      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirm Deletion"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: '#635bff',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1565c0',
                color: 'white'
              }
            }}
            onClick={handleConfirmDelete}
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: '#635bff',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1565c0',
                color: 'white'
              }
            }}
            onClick={handleCloseConfirmDialog}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default EmailConfigurationForm; 